<template>
  <section class="auto-complete">
    <input
      ref="field"
      v-model="model.search"
      @input="input"
      @focus="focusInput"
      @blur="closeDrop"
      :class="css"
      type="text"
      v-bind="$attrs"
    />
    <div
      class="auto-list"
      :class="{ show : openDrop }"
      :style="`width: ${$refs.field && $refs.field.clientWidth || 0}px`"
    >
      <div
        v-for="(item, i) in filteredList"
        @click="selectItem(item, $event)"
        :key="i"
        class="auto-list-item"
      >
        <span>{{ item.name }}</span>
        <span>{{ item.email }} {{ item.phone ? `/ ${item.phone}` : '' }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'autocomplete2',

  inheritAttrs: false,
  props: ['model', 'list', 'css'],
  data () {
    return {
      openDrop: false,
      search: ''
    }
  },
  computed: {
    filteredList () {
      return this.list
        .filter(x => String(x.name).toUpperCase().includes(this.model.search.toUpperCase()) ||
        String(x.email).toUpperCase().includes(this.model.search.toUpperCase()) ||
        // eslint-disable-next-line no-useless-escape
        String(x.phone).toUpperCase().replace(/[- \(\)]/g, '').includes(this.model.search.toUpperCase()))
        .sort()
        .filter((x, i) => i < 5)
    }
  },
  methods: {
    input () {
      this.$emit('CustomEventInputChanged', this.model.search)
      for (const property in this.model) if (property !== 'search') this.model[property] = null
    },
    selectItem (value) {
      for (const property in value) this.model[property] = value[property]
      this.openDrop = false
    },
    closeDrop () {
      setTimeout(() => { this.openDrop = false }, 200)
    },
    focusInput ($event) {
      $event.target.select()
      this.openDrop = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.auto-complete {
  position: relative;

  input {
    width: 100%;
    box-sizing: border-box;
    text-transform: capitalize;
  }

  &.error {
    input {
      border: 1px solid $error-color;
      background-color: rgba(136, 0, 0, 0.1);
    }
  }

  .auto-list {
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 1px 1px 5px -1px rgba(0,0,0,0.2);
    position: absolute;
    overflow-x: hidden;
    max-height: 0;
    visibility: hidden;
    transition: max-height 0.8s;
    z-index: 9;
    &.show {
      max-height: 250px;
      overflow-x: scroll;
      visibility: visible;
    }
  }

  .auto-list-item {
    padding: 8px 10px;
    font-size: 1em;
    border-bottom: 1px dashed #ddd;
    cursor: pointer;
    &:hover {
      background-color: rgba(86, 0, 112, 0.1);
    }
    span {
      display: block;
    }
    span:nth-child(2) {
      font-size: 0.85em;
      color: #777;
    }
  }
}
</style>
